import script from "./DeleteIntentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteIntentModal.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteIntentModal.vue?vue&type=style&index=0&id=5a7bf7a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7bf7a8"]])

export default __exports__